<template>
  <div class="d-block d-sm-inline-block">
    <div class="d-block d-sm-inline-block">
      <label class="mt-2">โปรโมชัน/ กิจกรรมอื่นๆ :</label>
    </div>
    <div class="d-block d-sm-inline-block my-2 my-sm-0 mx-sm-2">
      <v-menu
        v-model="isShow"
        :close-on-content-click="false"
        max-height="500px"
        style="postion: relative" >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="btn-activator"
            v-bind="attrs"
            v-on="on"
            outlined
            color="var(--theme-color-two)">
            โปรโมชัน/กิจกรรมทั้งหมด
            {{suffixCount}}
            <v-icon class="float-right">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-icon @click="isShow=false" class="close">mdi-close</v-icon>
        <v-list
          v-for="(color, name) in types"
          :key="name">
          <v-list-item v-if="getPromotionsByType(name).length > 0">
            <v-list-item-icon>
              <v-icon :color="color">mdi-square</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="item in getPromotionsByType(name)"
            :key="item.Id">
            <v-list-item-content>
              <v-checkbox
                v-model="itemIds"
                :label="item.PromotionName__c"
                :value="item.Id"
                color="var(--theme-color-one)"
                hide-details
                class="my-0"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isShow: false,
      itemIds: [],
    }
  },
  props: {
    value: { types: Number, require: true },
  },
  mounted() {
    this.itemIds = this.value
  },
  watch: {
    itemIds (newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) this.$emit('input', newVal)
    },
    value (newVal) {
      this.itemIds = newVal
    },
  },
  methods: {
    getPromotionsByType(type) {
      return this.$store.getters['Calendar/getPromotionsByType'](type)
    },
  },
  computed: {
    ...mapGetters({
      promotions: 'Calendar/getPromotions',
      types: 'Calendar/getTypes',
    }),
    suffixCount() {
      const count = this.itemIds.length
      if (count == 0) return ''
      return `(${count})`
    }
  },
}
</script>

<style scoped>
.close {
  position: fixed;
  top:5px;
  right:5px;
  z-index: 2000;
}
.btn-activator .v-btn__content{
  align-items: justify;
}
@media (max-width: 600px) {
  .btn-activator {
    width: 100%;
  }
}
</style>